import { type SentimentMode } from 'features/charts-v2/components/SentimentFilterCard'

// Shared by FilterControl (the sidebar's SentimentFilterCard) and
// FilterSelectionPopover (the popover's Sentiment pane) — both need the same
// mode fallback so a numeric-only filter's mode choice round-trips
// identically through either UI.
//
// Mode: record when post_sentiment has values; sentence when sentiment has
// values; otherwise fall back to entry existence so a numeric-only filter can
// persist a mode choice (empty post_sentiment entry = Record marker, absence
// of both entries = Sentence default).
export const deriveSentimentMode = (
  sentimentSelection: { values?: string[] | null } | null,
  postSentimentSelection: { values?: string[] | null } | null,
): SentimentMode =>
  (postSentimentSelection?.values?.length ?? 0) > 0
    ? 'record'
    : (sentimentSelection?.values?.length ?? 0) > 0
      ? 'sentence'
      : postSentimentSelection !== null
        ? 'record'
        : 'sentence'
